import React from "react"
import styled from "styled-components"
import media from "styled-media-query"

import { colors } from "~/styles"

export const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  display: flex;
  justify-content: center;
  padding: 5rem 2rem 0;

  ${media.greaterThan("medium")`
    padding: 8rem 2rem 0;
  `}

  z-index: 100;

  &:before {
    position: absolute;
    content: "";
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    background-color: rgba(0, 0, 0, 0.7);
  }
`

export const Dialog = styled.div`
  position: relative;

  animation: show 1s cubic-bezier(0.19, 1, 0.22, 1);

  @keyframes show {
    from {
      opacity: 0;
      margin-top: -50rem;
    }
    to {
      opacity: 1;
      margin-top: 0;
    }
  }
`

export const Body = styled.div`
  position: relative;

  width: 90vw;
  max-width: 1200px;
  height: 40rem;

  display: flex;

  border-radius: 3rem;
  background-color: #fff;
  overflow: hidden;
  z-index: 10;

  ${media.greaterThan("medium")`
    height: 60rem;
  `}
`

export const Figure = styled.figure`
  flex: 1;
  overflow: hidden;
  display: none;

  ${media.greaterThan("medium")`
    display: block;
  `}

  img {
    object-fit: cover;
  }
`

export const Content = styled.div`
  flex: 1;
  height: 100%;
  padding: 2rem 3rem;

  display: flex;
  flex-direction: column;
  justify-content: space-around;

  color: #666;
  font-size: 1.4rem;

  ${media.greaterThan("medium")`
    padding: 8rem 7rem;
  `}

  h1 {
    color: ${colors.primary};
    font-size: 2.2rem;
  }
`

export const Close = styled.button.attrs({
  children: <span>&times;</span>,
})`
  all: unset;
  position: absolute;
  top: -4.5rem;
  right: 0;

  color: #fff;
  font-size: 3rem;

  transition: 0.3s;
  z-index: 20;

  &:hover {
    opacity: 0.8;
    cursor: pointer;
  }
`
